module.exports = (parcelRequire.load("jwxGM")).then(() => parcelRequire('kgs7L'));